import { useState } from "react";

export default function ConnectForm() {
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [shake, setShake] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setShake(true);
      setTimeout(() => setShake(false), 500);
      return;
    }
    setSending(true);

    const baseUrl = process.env.REACT_APP_API_URL || "https://hogchomepage-60067036113.development.catalystserverless.in";
    try {
      const response = await fetch(`${baseUrl}/server/emailleadcollector/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name.trim(),
          email: form.email.trim(),
          phone_no: "",
          source: form.company.trim() || "HOGC Website",
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSending(false);
        setSent(true);
      } else {
        setSending(false);
        setShake(true);
        setTimeout(() => setShake(false), 500);
        console.error("API error:", data?.message);
      }
    } catch (err) {
      setSending(false);
      setShake(true);
      setTimeout(() => setShake(false), 500);
      console.error("Network error:", err);
    }
  };

  if (sent) {
    return (
      <div id="stage-form">
        <div className="sf-eyebrow">Get in Touch</div>
        <h2 className="sf-title">Connect</h2>
        <p className="sf-sub">Let's start a conversation.</p>
        <p className="sf-success visible">Message sent — we'll be in touch soon.</p>
      </div>
    );
  }

  return (
    <div id="stage-form">
      <div className="sf-eyebrow">Get in Touch</div>
      <h2 className="sf-title">Connect</h2>
      <p className="sf-sub">Let's start a conversation.</p>
      <div className="sf-fields">
        <div className="sf-row">
          <div className="sf-field">
            <label className="sf-label">
              Name <span className="sf-req">*</span>
            </label>
            <input
              className="sf-input"
              type="text"
              placeholder="Your name"
              value={form.name}
              onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            />
          </div>
          <div className="sf-field">
            <label className="sf-label">
              Email <span className="sf-req">*</span>
            </label>
            <input
              className="sf-input"
              type="email"
              placeholder="you@company.com"
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
            />
          </div>
        </div>

        <div className="sf-row">
          <div className="sf-field">
            <label className="sf-label">
              Company <span className="sf-opt">optional</span>
            </label>
            <input
              className="sf-input"
              type="text"
              placeholder="Your company"
              value={form.company}
              onChange={(e) => setForm((f) => ({ ...f, company: e.target.value }))}
            />
          </div>
          <div className="sf-field">
            <label className="sf-label">
              Description <span className="sf-req">*</span>
            </label>
            <textarea
              className="sf-input sf-textarea"
              placeholder="Tell us about your project…"
              rows={2}
              value={form.message}
              onChange={(e) => setForm((f) => ({ ...f, message: e.target.value }))}
            />
          </div>
        </div>
        <button className={`sf-submit${shake ? " sf-shake" : ""}`} disabled={sending} onClick={handleSubmit}>
          <span className="sf-submit-text">{sending ? "Sending…" : "Send Message"}</span>
          <span className="sf-submit-arrow">→</span>
        </button>
      </div>
    </div>
  );
}
